<template>
<div>
    <div :style="{ opacity: (loadingApp || navigating) ? 0 : 1 }">
        <router-view v-if="!loadingApp && !oldLink && !maintenance" />
    </div>
    
    <div v-if="loading || loadingApp" class="main-spinner card-shadow">
        <Spinner v-if="loading" :text="loadingText" />
        <Spinner v-if="loadingApp" :text="loadingAppText" />
    </div>

    <div v-if="oldLink" class="main-error card-shadow">
        <div style="text-align: center;">
            <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(2.0);">
                <path d="M16 0C7.2 0 0 7.2 0 16C0 24.8 7.2 32 16 32C24.8 32 32 24.8 32 16C32 7.2 24.8 0 16 0ZM16 29.9C8.3 29.9 2.1 23.7 2.1 16C2.1 8.3 8.3 2.1 16 2.1C23.7 2.1 29.9 8.3 29.9 16C29.9 23.7 23.7 29.9 16 29.9Z"/>
                <path d="M22.6765 9.32353C22.2451 8.89216 21.5457 8.89216 21.1144 9.32353L16 14.4379L10.8856 9.32353C10.4543 8.89216 9.75489 8.89216 9.32353 9.32353C8.89216 9.75489 8.89216 10.4543 9.32353 10.8856L14.4379 16L9.32353 21.1144C8.89216 21.5457 8.89216 22.2451 9.32353 22.6765C9.75489 23.1078 10.4543 23.1078 10.8856 22.6765L16 17.5621L21.1144 22.6765C21.5457 23.1078 22.2451 23.1078 22.6765 22.6765C23.1078 22.2451 23.1078 21.5457 22.6765 21.1144L17.5621 16L22.6765 10.8856C23.1078 10.4543 23.1078 9.7549 22.6765 9.32353Z"/>
            </svg>
        </div>
        <div style="text-align: center; margin-top: 30px;">
            <label>invalid link</label>
        </div>
    </div>

    <div v-if="maintenance" class="main-error card-shadow">
        <div style="text-align: center;">
            <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(2.0);">
                <path d="M 5 3 L 3 5 L 4.40625 7.109375 C 4.77725 7.666375 5.4023125 8 6.0703125 8 L 6.5859375 8 L 9.2929688 10.707031 L 10.707031 9.2929688 L 8 6.5859375 L 8 6.0703125 C 8 5.4023125 7.666375 4.77725 7.109375 4.40625 L 5 3 z M 18 3 C 15.791 3 14 4.791 14 7 C 14 7.5862513 14.132749 8.1389203 14.359375 8.640625 L 4.2929688 18.707031 C 3.9019687 19.098031 3.9019687 19.731094 4.2929688 20.121094 L 4.8789062 20.707031 C 5.2689063 21.098031 5.9019687 21.098031 6.2929688 20.707031 L 12.128906 14.871094 L 17.855469 20.597656 C 18.391469 21.133656 19.258922 21.134656 19.794922 20.597656 L 20.597656 19.794922 C 21.133656 19.259922 21.133656 18.391469 20.597656 17.855469 L 14.871094 12.128906 L 16.359375 10.640625 C 16.86108 10.867251 17.413749 11 18 11 C 20.209 11 22 9.209 22 7 C 22 6.414 21.867625 5.860375 21.640625 5.359375 L 19 8 L 17 6 L 19.640625 3.359375 C 19.139625 3.132375 18.586 3 18 3 z"/>
            </svg>
        </div>
        <div style="text-align: center; margin-top: 30px;">
            <label>Det pågår vedlikehold av frakt-tabellen. Vennligst prøv igjen senere.</label>
        </div>
    </div>

    <div v-if="showHelp" class="main-help">
        <div class="main-help-background" />
        <div class="main-help-container">
            <div class="main-help-content">
                <h1>{{__('help_header')}}</h1>
                <p v-html="__('help_message')"></p>
                <div>
                    <vm-button :text="'OK'" @clicked="showHelp = false" />
                </div>
            </div>

        </div>
    </div>

</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import axios from 'axios';
import maxbo from './maxbo';
import log from './log';
import superoffice from './superoffice';
import shippingapi from './shippingapi';
import verified from './verified';

import Spinner from './components/nav/Spinner';

export default {
name: 'App',
components: {
    Spinner
},
data() {
    return {
        maintenance: false,
        sheetName: 'maxbo-discount-agreements',
        navigating: false,
        loading: false,
        loadingText: '',
        loadingApp: true,
        loadingAppText: 'Laster skjema...',
        loadingBackground: false,
        oldLink: false,
        showHelp: false,
        cachedData: {
            customer: undefined,
            shipping: undefined,
            envelope: undefined,
            flow: undefined
        },
        sheetData: {
            values: {}
        },
        approvers: [
            {
                value: '',
                display: 'Laster inn godkjennere...'
            }
        ],
        accessList: undefined,
        skEnabled: false,
        updated: false,
        isEditor: false,
        confirmed: false
    }
},
methods: {
    navigate(route, instant) {
        if (instant) {
            this.$router.push(route);
            return;
        }
        this.navigating = true;
        this.$router.push(route);
        setTimeout(() => {
            this.navigating = false;
        }, 500);
    },
    setLoading(value, text) {
        this.loadingText = text;
        this.loading = value;
    },
    async loadInBackground() {
        this.loadingBackground = true;
        const [approvers, access] = await Promise.all([
            axios.get(`https://sheets.web-services.verified.eu/${this.sheetName}/approvers`),
            axios.get(`https://sheets.web-services.verified.eu/${this.sheetName}/access`)
        ]);
        this.approvers = [];
        for (let key in approvers.data) {
            this.approvers.push({
                value: approvers.data[key].email,
                display: key,
                name: approvers.data[key].fname + ' ' + approvers.data[key].lname,
                fname: approvers.data[key].fname,
                lname: approvers.data[key].lname,
                email: approvers.data[key].email,
                key: key
            });
        }
        this.accessList = [];
        for (let key in access.data) {
            this.accessList.push(access.data[key]);
        }
        for (let i in this.$children) {
            if (this.$children[i].$vnode.tag.includes('Shipping')) this.$children[i].onBackgroundLoadingCompleted();
        }
        this.loadingBackground = false;
    },
    async getCustomer() {
        if (this.cachedData.customer) return this.cachedData.customer;
        this.cachedData.customer = await superoffice.getCustomer(this.$route.query);
        return this.cachedData.customer;
    },
    async getShipping() {
        if (this.cachedData.shipping) return this.cachedData.shipping;
        const response = await shippingapi.getShipping(this.cachedData.customer);
        this.cachedData.shipping = response.shipping;
        return this.cachedData.shipping;
    },
    getFlow() {
        return this.cachedData.flow;
    },
    getEnvelope() {
        return this.cachedData.envelope;
    }
},
async created() {
    log.v('app created');

    if (this.maintenance) {
        log.w('maintenance, aborting load...');
        this.loadingApp = false;
        return;
    }

    const [translations, values, thresholds] = await Promise.all([
        axios.get(`https://sheets.web-services.verified.eu/${this.sheetName}/translations`),
        axios.get(`https://sheets.web-services.verified.eu/${this.sheetName}/values`),
        axios.get(`https://sheets.web-services.verified.eu/${this.sheetName}/thresholds`),
    ]);
    this.$root.translations = translations.data;
    this.sheetData.values = values.data;
    this.sheetData.thresholds = thresholds.data;


    if (this.$route.query.document_uid && this.$route.query.access_token) {
        log.v('fetching envelope');
        await verified.authenticateBearer(this.$route.query.access_token);
        this.cachedData.envelope = await verified.getEnvelope(this.$route.query.document_uid);

        const userdata = await verified.getUserdata(this.cachedData.envelope);
        console.log('userdata', userdata);
        maxbo.socreds = userdata.socreds || 'error';

        this.cachedData.flow = userdata.flow;

        // Check if this step is already completed
        let linkOk = true;
        if (this.cachedData.flow.step != Number(this.$route.query.step)) {
            // This mail-link has already been opened and submitted
            log.w('this link has already been submitted');
            if (this.cachedData.flow.action == 'confirm' || this.cachedData.flow.action == 'finalconfirm' || this.cachedData.flow.action == 'completed') {
                // Allow users to view/download PDF from old links
                log.v('allow PDF viewing/downloading');
                this.confirmed = true;
            }else {
                log.w('showing invalid link message');
                linkOk = false;
                this.oldLink = true;
            }
        }
        
        if (linkOk) {
            // Load userdata
            this.cachedData.customer = userdata.customer;
            this.cachedData.shipping = userdata.shipping;

            // Redirect to correct view
            if (userdata.flow.status.wasApproved || userdata.flow.status.wasRejected) {
                // Approved or rejected
                this.isEditor = true;
                if (userdata.flow.status.wasApproved) {
                    // Approved - redirect to confirm-view
                    this.navigate({path: '/confirm', query: this.$route.query}, true);
                }else {
                    // Rejected - redirect to shipping-view to make changes
                    this.navigate({path: '/shipping', query: this.$route.query}, true);
                }
            }else {
                // Waiting for approval
                this.navigate({path: '/approve', query: this.$route.query}, true);
            }
        }
    }else {
        this.loadingAppText = 'Henter kunde fra SuperOffice...';
        await this.getCustomer();
    }

    this.loadingApp = false;
    this.loadInBackground();
}
}
</script>

<style>

html { 
    background: url(../public/mp-bg.jpg) no-repeat center center fixed; 
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}

body {
    margin: 0px;
    font-family: BrownPro,Roboto,sans-serif;
}

.form-container {
    display: flex;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 60px;
    padding-top: 20px;
    padding-bottom: 100px;
}

.card-shadow {
    -webkit-box-shadow: 0.5px 0.5px 3px 0px rgba(0,0,0,0.26);
    -moz-box-shadow: 0.5px 0.5px 3px 0px rgba(0,0,0,0.26);
    box-shadow: 0.5px 0.5px 3px 0px rgba(0,0,0,0.26);
}

.no-select {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
    supported by Chrome, Opera and Firefox */
}

.main-spinner {
    position: absolute;
    width: 340px;
    height: 250px;
    top: 34%; left: 50%;
    margin-left: -170px;
    padding-top: 35px;
    padding-left: 160px;
    border-radius: 5px;
    background-color: white;
    box-sizing: border-box;
}

.main-message {
    position: absolute;
    width: 400px;
    height: 250px;
    top: 34%; left: 50%;
    margin-left: -200px;
    padding-top: 35px;
    padding-left: 200px;
    border-radius: 5px;
    background-color: white;
    box-sizing: border-box;
}
.main-message path {
    fill: #004976;
}

.main-error {
    position: absolute;
    width: 600px;
    min-height: 150px;
    top: 30%; left: 50%;
    margin-left: -300px;
    font-size: 18px;
    padding-top: 45px;
    padding-bottom: 50px;
    border-radius: 5px;
    background-color: white;
    box-sizing: border-box;
}
.main-error path {
    fill: #B62537;
}


.approval-info-c {
    width: 100%;
    margin-top: 5px;
    margin-bottom: 10px;
    padding: 0px 6px;
    box-sizing: border-box;
}
.approval-info {
    display: flex;
    width: 100%;
    border-radius: 3px;
    background-color: tomato;
    box-sizing: border-box;
}
.approval-none {
    background-color: limegreen;
}
.approval-info-icon {
    width: 40px;
    padding-top: 2px;
    padding-left: 5px;
}
.approval-info-text {
    flex-grow: 100;
    padding-top: 10px;
}
.approval-info path {
    fill: red;
}
.approval-none path {
    fill: green;
}


.main-help {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    min-height: 100vh;
    z-index: 10;
}
.main-help-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.7;
}
.main-help-container {
    position: relative;
    padding-top: 100px;
    min-width: 100px;
    max-width: 90%;
    margin: 0 auto;
    min-height: 100px;
}
.main-help-content {
    position: relative;
    width: 100%;
    margin: 0 auto;
    padding: 20px 40px;
    color: #234875;
    min-height: 100px;
    overflow: hidden;
    border: solid 2px black;
    border-radius: 5px;
    background-color: white;
    -webkit-box-shadow: 1px 1px 10px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 1px 1px 10px 0px rgba(0,0,0,0.75);
    box-shadow: 1px 1px 10px 0px rgba(0,0,0,0.75);
    box-sizing: border-box;
}

</style>
